var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg39(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 300,
    height: 300,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-0.1488112073783736"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126 0H43L0 120.531H36L6 227L110 80.354H73L126 0Z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M126 0H43L0 120.531H36L6 227L110 80.354H73L126 0Z",
    fill: "rgba(191, 191, 191, 100)",
    transform: "scale(2.380952380952381, 1.3215859030837005)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M126 0H43L0 120.531H36L6 227L110 80.354H73L126 0Z",
    fill: "none",
    stroke: "#0c0c0c",
    strokeWidth: 0,
    clipPath: "url(#clip-0.1488112073783736)",
    transform: "scale(2.380952380952381, 1.3215859030837005)",
    strokeDasharray: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg39);
export default __webpack_public_path__ + "static/media/39.09562d0285b221339f6c84610049d9ff.svg";
export { ForwardRef as ReactComponent };